

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: 'tventas',
  data () {
    return {
      tabla_data: [],
      loading: true,
      tbv: null,
      tvp: null,
      ventas: [],
      ventast_tabla: 0,

      f_c: {
        desde: this.currentdate(),
        hasta: this.currentdate(),
        estado: 9
      }

    }
  },
  props: ['porventas'],

  mounted: function () {
    this.loading = false
    $('.box').boxWidget()
  },

  methods: {

    consultar () {
      this.loading = true
      this.$http
        .post('/SERVER/scd/admin/altaUsers/', {
          'a': 'repo',
          'f': this.f_c
        }, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.status === 1) {
            this.tabla_data = response.data.data
          }
          this.loading = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/reps/reporte/tventas/tventas.js